import { Heading } from '@uhg-harmony/react';
import type { PortalLogin } from '@/types';
import imgClaimant from '@/assets/images/dol-claimant.png';
import imgPrescriber from '@/assets/images/dol-prescriber.png';
import imgStaff from '@/assets/images/dol-staff.png';
import styles from './PortalLoginSection.module.css';

interface PortalLoginSectionProps {
  portalLogins: PortalLogin[];
}

const ROLE_ICONS: Record<string, string> = {
  Claimant: imgClaimant,
  Prescriber: imgPrescriber,
  DOLStaff: imgStaff,
};

export function PortalLoginSection({ portalLogins }: PortalLoginSectionProps) {
  if (portalLogins.length === 0) {
    return null;
  }

  return (
    <section id="portal-login" className={styles.section} aria-labelledby="portal-login-heading">
      <Heading level="h2" id="portal-login-heading" className={styles.heading}>
        Portal Login
      </Heading>
      <div className={styles.loginList}>
        {portalLogins.map((login) => (
          <div
            key={login.portalLoginId}
            id={`portal-login-${login.code.toLowerCase()}`}
            className={styles.loginRow}
          >
            <div className={styles.role}>
              {ROLE_ICONS[login.code] && (
                <img src={ROLE_ICONS[login.code]} alt="" className={styles.icon} aria-hidden="true" />
              )}
              <Heading level="h3" className={styles.roleTitle}>{login.title}</Heading>
            </div>
            <div className={styles.details}>
              {login.description && <p>{login.description}</p>}
              {login.url && (
                <a
                  className={`${styles.loginButton} ${login.isDisable ? styles.disabled : ''}`}
                  href={login.isDisable ? undefined : login.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-disabled={login.isDisable}
                  aria-label={`${login.buttonText || 'Login'} to ${login.code}`}
                >
                  {login.buttonText || 'Login'}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}